import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import ExampleAR from "./ExampleAR";
import VideoFrame from "./VideoFrame"; // Make sure this matches the actual filename and is in PascalCase

function HomePage() {
  const [typedText, setTypedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Reset the page scroll and fix focus issues when returning from other pages
  useEffect(() => {
    // Force a complete page reset on navigation
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const words = [
      "Une nouvelle manière de rénover votre intérieur",
      "Votre outil pour sublimer vos oeuvres d'arts à travers la France",
      "Le mariage parfait entre l'art et l'innovation",
    ];
    const typingSpeed = 110;
    const deletingSpeed = 110;
    const pauseDuration = 1500;

    if (isDeleting) {
      if (charIndex > 0) {
        setTimeout(() => setCharIndex((prev) => prev - 1), deletingSpeed);
        setTypedText(words[currentWordIndex].slice(0, charIndex));
      } else {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    } else {
      if (charIndex < words[currentWordIndex].length) {
        setTimeout(() => setCharIndex((prev) => prev + 1), typingSpeed);
        setTypedText(words[currentWordIndex].slice(0, charIndex + 1));
      } else {
        setTimeout(() => setIsDeleting(true), pauseDuration);
      }
    }
  }, [charIndex, isDeleting, currentWordIndex]);

  const navigateToAR = (e) => {
    e.preventDefault();
    navigate('/example-ar');
  };

  const navigateToVideo = (e) => {
    e.preventDefault();
    navigate('/video-ar');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const email = e.target.elements.email.value;

    if (!email) {
      setSubmitStatus({
        type: "error",
        message: "Please enter a valid email.",
      });
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(
        "https://backend-landingpage-wq8j.onrender.com/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ email }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus({
          type: "success",
          message: "Merci pour votre intérêt lié à notre projet",
        });
        e.target.reset();

        setTimeout(() => {
          const statusElement = document.querySelector(".submit-status");
          if (statusElement) {
            statusElement.classList.add("fade-out");
          }

          setTimeout(() => {
            setSubmitStatus(null);
          }, 400);
        }, 3000);
      } else {
        setSubmitStatus({
          type: "error",
          message: `Failed to send email: ${result.error}`,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus({
        type: "error",
        message: "An error occurred while sending the email.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="App dark-mode">
      <div className="navigation-buttons">
        <button
          onClick={navigateToAR}
          className="ar-nav-button"
          aria-label="View AR Example"
        >
          <i
            className="bi bi-badge-3d"
            style={{
              fontSize: "28px",
              color: "white",
            }}
          ></i>
        </button>
        <button
          onClick={navigateToVideo}
          className="video-nav-button"
          aria-label="View Video Demo"
        >
          <i
            className="bi bi-film"
            style={{
              fontSize: "28px",
              color: "white",
            }}
          ></i>
        </button>
      </div>
      <header className="App-header">
        <div className="header-title">
          <h1>Prophecy</h1>
          <div className="xr-box">XR</div>
        </div>
        <h2>DESIGN BEYOND IMAGINATION</h2>
        <p className="highlighted-text">Prophecy XR c'est :</p>
        <p className="highlighted-text typing-text">{typedText}</p>
        <form onSubmit={handleSubmit}>
          <input
            name="email"
            type="email"
            placeholder="Entrez votre email ici pour etre informé "
            className="newsletter-input"
            disabled={isSubmitting}
          />
          <button
            type="submit"
            className="newsletter-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Envoi en cours..." : "Envoyer"}
          </button>
          {submitStatus && (
            <div className={`submit-status ${submitStatus.type}`}>
              {submitStatus.message}
            </div>
          )}
        </form>
      </header>
    </div>
  );
}

function AppWrapper() {
  // Set document class to dark-mode on initial render
  useEffect(() => {
    document.documentElement.className = "dark-mode";
  }, []);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/example-ar" element={<ExampleAR />} />
      <Route path="/video-ar" element={<VideoFrame />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;